import { formatHtml } from "@trumpf/ux.common-storybook";
import { TeaserNewsroomTemplate } from "./teaser-newsroom.templates";

export default {
    title: "Website/Partial Templates/Teaser/Newsroom",
    render: TeaserNewsroomTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        variant: "default",
    },
    argTypes: {
        variant: {
            options: ["default", "with en tag"],
            control: { type: "radio" },
        },
    },
};

export const Default = {};
